(function () {
    $('#loyalty-filter')
        .find('select')
        .change(function (e) {
            $(this).closest('form').submit();
        });
})();
